import { render, staticRenderFns } from "./newContainer.vue?vue&type=template&id=c9b58604"
import script from "./newContainer.vue?vue&type=script&lang=js"
export * from "./newContainer.vue?vue&type=script&lang=js"
import style0 from "./newContainer.vue?vue&type=style&index=0&id=c9b58604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports